import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/assets/img/pdf/initial-screen.jpg'
import _imports_1 from '../../../../public/assets/img/pdf/usb-card-pdf.png'


const _withScopeId = n => (_pushScopeId("data-v-7a6f2dba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"1123px","width":"801px","max-height":"1236px","max-width":"801px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Deckblatt mit Acon-Logo",
    style: {"height":"1123px","width":"801px","max-height":"1236px","max-width":"801px"}
  })
], -1))
const _hoisted_4 = { class: "landing_page" }
const _hoisted_5 = { class: "title-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "landing_text_header text-5xl md:text-7xl",
  "data-cy": "pdf-coverpage-header"
}, " ACON 360° ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-4xl" }, " Inventory_Heizzentrale ", -1))
const _hoisted_8 = { class: "mt-2 text-xl flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-0 w-40" }, "Objekt:", -1))
const _hoisted_10 = {
  class: "mt-0",
  "data-cy": "pdf-coverpage-street"
}
const _hoisted_11 = { class: "text-xl flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-0 w-40" }, null, -1))
const _hoisted_13 = {
  class: "mt-0",
  "data-cy": "pdf-coverpage-city"
}
const _hoisted_14 = { class: "text-xl flex mt-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-0 w-40" }, "Berichtnummer:", -1))
const _hoisted_16 = {
  class: "mt-0",
  "data-cy": "pdf-coverpage-begehungsdatum"
}
const _hoisted_17 = {
  class: "mt-2 mb-0 text-base font-bold",
  "data-cy": "genericContent-header"
}
const _hoisted_18 = {
  class: "text-xxs",
  "data-cy": "zusaetzliche-maengel"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = {
  key: 2,
  "data-cy": "heizzentrale-zugang"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-2 mb-0" }, " Zugang ", -1))
const _hoisted_24 = { class: "text-xs my-0 overflow-ellipsis" }
const _hoisted_25 = { "data-cy": "contentpage-fazit" }
const _hoisted_26 = { class: "mt-2 mb-0" }
const _hoisted_27 = { class: "text-xs my-0" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mt-8 text-base",
  "data-cy": "final-page-header"
}, " Digitale Dokumentationsdaten ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  "data-cy": "usb-card",
  src: _imports_1,
  style: {"height":"300px","width":"440px"}
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "mt-8 mb-0 text-base",
  "data-cy": "hinweis-title"
}, " Hinweis ", -1))
const _hoisted_32 = {
  class: "flex flex-col",
  "data-cy": "hinweis-text"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 ml-0 text-xxs text-justify" }, " Den dargelegten Ausführungen und Bewertungen liegt die Beauftragung einer Heizzentralen-Bestandsaufnahme inkl. Funktionsprüfung zugrunde. Im Rahmen der Heizzentralen-Bestandsaufnahme inkl. Funktionsprüfung erfolgt eine Vor-Ort-Bestandsaufnahme durch zwei technische Projektmanager inkl. Daten- sowie Mängelerfassung wie folgt: Visuelle Bestandsaufnahme sowie funktionale Zustandserfassung und -überprüfung aller Komponenten der Heizzentrale. Bewertung der Anlage hinsichtlich Anlagenbetrieb (Auslegung, Dimensionierung, Effizienz und Wartungszustand) anhand der ermittelten Einstell- und Messwerte sowie unter Berücksichtigung gesetzlicher Vorschriften und sicherheitstechnischer Empfehlungen. Die Bewertung der Anlage erfolgt über die systematische Vergabe von Maluspunkten je erfasstem Mangel, deren Summe als Indikator für den Gesamtzustand der Heizzentrale dient. Darüber hinausgehend ist dem zuständigen Projektleiter die Möglichkeit gegeben, durch eine übergeordnete Vergabe von Maluspunkten (negativ sowie positiv) Korrekturen bzw. Anpassungen vorzunehmen. ", -1))
const _hoisted_34 = { class: "ml-0 text-xxs text-justify flex flex-wrap" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"4px 0px 0px 0px"} }, " Die Klassifizierung der einzelnen Mängel erfolgt nach Art ", -1))
const _hoisted_36 = { class: "flex items-center ml-1" }
const _hoisted_37 = { class: "flex items-center mx-0" }
const _hoisted_38 = { class: "flex items-center mx-0" }
const _hoisted_39 = { class: "flex items-center mx-0" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-xxs text-justify",
  style: {"margin":"0px 0px 0px 0px"}
}, " sowie relevantem Gewerk. Auf Seite 1 des Dokumentes wird die Maluspunkte-Gesamtsumme sowie die Maluspunkte- ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-xxs text-justify",
  style: {"margin":"0px 0px 0px 0px"}
}, " Summe je Unterkategorie (Heizzentrale, Wäremeerzeuger, Anlagenkomponenten, Nachspeisung) aufgezeigt. Auf den darauffolgenden Seiten sind die erfassten Daten und Mängel je Unterkategorie (Heizzentrale, Wäremeerzeuger, Anlagenkomponenten, Nachspeisung) detailliert ausgewiesen. Danach werden alle Mängel gegebenenfalls mit Beschreibung und Bilddokumentation tabellarisch aufgelistet. ", -1))
const _hoisted_42 = {
  class: "mt-8",
  "data-cy": "ansprechpartner"
}
const _hoisted_43 = { class: "flex mt-4" }
const _hoisted_44 = {
  class: "flex flex-col w-1/3",
  "data-cy": "signatur-1"
}
const _hoisted_45 = { style: {"height":"70px"} }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "border-top-dotted-1 ml-4" }
const _hoisted_48 = { class: "text-xxs mt-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = {
  class: "flex flex-col w-1/3",
  "data-cy": "signatur-2"
}
const _hoisted_51 = { style: {"height":"70px"} }
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "border-top-dotted-1 ml-4" }
const _hoisted_54 = { class: "text-xxs mt-2" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = {
  class: "flex flex-col w-1/3",
  "data-cy": "signatur-3"
}
const _hoisted_57 = { style: {"height":"70px"} }
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "border-top-dotted-1 ml-4" }
const _hoisted_60 = { class: "mt-2" }
const _hoisted_61 = { class: "text-xxs my-0" }
const _hoisted_62 = { class: "text-xxs my-0" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xxs my-0" }, " ACON Energie Management GmbH ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!
  const _component_PdfHzbaOverviewPage = _resolveComponent("PdfHzbaOverviewPage")!
  const _component_pdf_page_header = _resolveComponent("pdf-page-header")!
  const _component_PdfMSEDataTable = _resolveComponent("PdfMSEDataTable")!
  const _component_pdf_image_row = _resolveComponent("pdf-image-row")!
  const _component_pdf_data_section_summary = _resolveComponent("pdf-data-section-summary")!
  const _component_pdf_color_codes = _resolveComponent("pdf-color-codes")!
  const _component_PdfHzbaMaengelPage = _resolveComponent("PdfHzbaMaengelPage")!
  const _component_pdf_custom_input_page = _resolveComponent("pdf-custom-input-page")!
  const _component_PdfChip = _resolveComponent("PdfChip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.detailPages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_pdf_a4_page, {
            class: "logo_page",
            "no-margin": "",
            "pdf-key": _ctx.lang
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.immobilie.strasse), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.immobilie.plz) + " " + _toDisplayString(_ctx.immobilie.stadt), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.moment(_ctx.ba.begehungsdatum).format("MM-YYYY")), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["pdf-key"]),
          (_ctx.tableOfContentMSEData)
            ? (_openBlock(), _createBlock(_component_PdfHzbaOverviewPage, {
                key: 0,
                lang: _ctx.lang,
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                "table-of-content-m-s-e-data": _ctx.tableOfContentMSEData
              }, null, 8, ["lang", "ba", "immobilie", "table-of-content-m-s-e-data"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailPages, (detailPage, key) => {
            return (_openBlock(), _createBlock(_component_pdf_a4_page, {
              key: key,
              "pdf-key": _ctx.lang,
              "data-cy": "generic-content-page"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_pdf_page_header, {
                  immobilie: _ctx.immobilie,
                  hzba: _ctx.ba,
                  "tech-data": _ctx.tableOfContentFragenblocks,
                  page: _ctx.pagecounterStartDetailPage + key,
                  "max-pages": _ctx.pagecounterTotalPages,
                  active: detailPage.fragenblock?.getTitle(),
                  lang: _ctx.lang
                }, null, 8, ["immobilie", "hzba", "tech-data", "page", "max-pages", "active", "lang"]),
                _createElementVNode("h2", _hoisted_17, _toDisplayString(detailPage.fragenblock.getTitle(_ctx.lang) +
              (detailPage.titleSuffix || "")), 1),
                (detailPage.fragenblockMSERows)
                  ? (_openBlock(), _createBlock(_component_PdfMSEDataTable, {
                      key: 0,
                      data: detailPage.fragenblockMSERows,
                      "show-title": true,
                      "value-title": null,
                      lang: _ctx.lang
                    }, null, 8, ["data", "lang"]))
                  : _createCommentVNode("", true),
                (detailPage.freieMaengelsMSERows?.length > 0)
                  ? (_openBlock(), _createBlock(_component_PdfMSEDataTable, {
                      key: 1,
                      data: detailPage.freieMaengelsMSERows,
                      "max-shown-items": detailPage.freieMaengelsMaxShownItems,
                      "show-title": false,
                      "short-title": true,
                      "hide-mangel-anzahl": true,
                      "value-title": null,
                      lang: _ctx.lang
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          (
                detailPage.freieMaengelsMSERows.length -
                  detailPage.freieMaengelsMaxShownItems ===
                  1
              )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " 1 weiterer Mangel ist in der Übersicht der Mängel aufgeführt "))
                            : _createCommentVNode("", true),
                          (
                detailPage.freieMaengelsMSERows.length -
                  detailPage.freieMaengelsMaxShownItems >
                  1
              )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(detailPage.freieMaengelsMSERows.length -
                  detailPage.freieMaengelsMaxShownItems) + " weitere Mängel sind in der Übersicht der Mängel aufgeführt ", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["data", "max-shown-items", "lang"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  (detailPage?.title === 'Nachspeisung' && detailPage.bilder)
                    ? (_openBlock(), _createBlock(_component_pdf_image_row, {
                        key: 0,
                        "image-objects": detailPage.bilder,
                        "hide-titles": "",
                        "max-images": 3
                      }, null, 8, ["image-objects"]))
                    : _createCommentVNode("", true),
                  (detailPage?.title !== 'Nachspeisung' && detailPage.bilder)
                    ? (_openBlock(), _createBlock(_component_pdf_image_row, {
                        key: 1,
                        "image-objects": detailPage.bilder,
                        "hide-titles": ""
                      }, null, 8, ["image-objects"]))
                    : _createCommentVNode("", true)
                ]),
                (key === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.useIdentifierFrageFinder(
                _ctx.ba,
                "hzba.heizzentrale-tab.allgemein-group.allgemein-modal.allgemein.zugang"
              )?.getCurrentInput() || "-"), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("h2", _hoisted_26, _toDisplayString(_ctx.t("hzba.pdf.fazit", 1, { locale: _ctx.lang })), 1),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(detailPage.zusammenfassung ? detailPage.zusammenfassung : "-"), 1)
                ]),
                _createVNode(_component_pdf_data_section_summary, {
                  title: detailPage.fragenblock?.getTitle(_ctx.lang),
                  data: detailPage.fragenblock?.maengelReport()?.getMSESummary()
                }, null, 8, ["title", "data"]),
                _createVNode(_component_pdf_color_codes, {
                  class: "ml-1",
                  lang: _ctx.lang
                }, null, 8, ["lang"])
              ]),
              _: 2
            }, 1032, ["pdf-key"]))
          }), 128)),
          _createVNode(_component_PdfHzbaMaengelPage, {
            mangelPages: _ctx.pagecounterMaengel,
            "onUpdate:mangelPages": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagecounterMaengel) = $event)),
            "pages-options": {
          currentStartPage: _ctx.pagecounterStartMaengelPage,
          maxPages: _ctx.pagecounterTotalPages,
        },
            lang: _ctx.lang,
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            "tech-data": _ctx.tableOfContentFragenblocks
          }, null, 8, ["mangelPages", "pages-options", "lang", "ba", "immobilie", "tech-data"]),
          _createVNode(_component_pdf_custom_input_page, {
            customInputPageCount: _ctx.pagecounterCustomInput,
            "onUpdate:customInputPageCount": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagecounterCustomInput) = $event)),
            immobilie: _ctx.immobilie,
            ba: _ctx.ba,
            "tech-data": _ctx.tableOfContentFragenblocks,
            lang: _ctx.lang,
            "custom-inputs": _ctx.customInputs,
            "pages-options": {
          currentStartPage: _ctx.pagecounterStartCustomInput,
          maxPages: _ctx.pagecounterTotalPages,
        }
          }, null, 8, ["customInputPageCount", "immobilie", "ba", "tech-data", "lang", "custom-inputs", "pages-options"]),
          _createVNode(_component_pdf_a4_page, { "pdf-key": _ctx.lang }, {
            default: _withCtx(() => [
              _createVNode(_component_pdf_page_header, {
                immobilie: _ctx.immobilie,
                hzba: _ctx.ba,
                "tech-data": [],
                page: _ctx.pagecounterStartAppointments,
                "max-pages": _ctx.pagecounterTotalPages,
                lang: _ctx.lang,
                "show-chapters": false
              }, null, 8, ["immobilie", "hzba", "page", "max-pages", "lang"]),
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", _hoisted_36, [
                    _createVNode(_component_PdfChip, {
                      color: "green",
                      "pdf-mode": ""
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("hzba.pdf.keineMaengel", 1, { locale: _ctx.lang })) + ",    ", 1)
                  ]),
                  _createElementVNode("span", _hoisted_37, [
                    _createVNode(_component_PdfChip, {
                      color: "blue",
                      "pdf-mode": ""
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("hzba.pdf.keineRelevantenMaengel", 1, { locale: _ctx.lang })) + ",    ", 1)
                  ]),
                  _createElementVNode("span", _hoisted_38, [
                    _createVNode(_component_PdfChip, {
                      color: "yellow",
                      "pdf-mode": ""
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("hzba.pdf.sicherheitsrelevanteMaengel", 1, {
                  locale: _ctx.lang,
                })) + ",    ", 1)
                  ]),
                  _createElementVNode("span", _hoisted_39, [
                    _createVNode(_component_PdfChip, {
                      color: "red",
                      "pdf-mode": ""
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("hzba.pdf.versorgungsrelevanteMaengel", 1, {
                  locale: _ctx.lang,
                })) + "   ", 1)
                  ]),
                  _hoisted_40,
                  _hoisted_41
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createTextVNode(_toDisplayString(_ctx.t("hzba.pdf.ansprechpartner", 1, { locale: _ctx.lang })) + " ", 1),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      (_ctx.ba.unterschrifts.length > 0)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.getPhotoUrl(_ctx.ba.unterschrifts[0].bild),
                            class: "object-cover mt-1",
                            style: {"height":"70px"}
                          }, null, 8, _hoisted_46))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createTextVNode(_toDisplayString(_ctx.ba.unterschrifts.length > 0 && _ctx.ba.unterschrifts[0]?.position
                      ? _ctx.ba.unterschrifts[0].position
                      : "Projektmanager") + ": " + _toDisplayString(_ctx.ba.unterschrifts.length > 0 && _ctx.ba.unterschrifts[0]?.name
                      ? _ctx.ba.unterschrifts[0].name
                      : "_________") + " am " + _toDisplayString(_ctx.moment(_ctx.ba.begehungsdatum).format("DD.MM.YYYY")), 1),
                        _hoisted_49
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      (_ctx.ba.unterschrifts.length > 1)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.getPhotoUrl(_ctx.ba.unterschrifts[1].bild),
                            class: "object-cover mt-1",
                            style: {"height":"70px"}
                          }, null, 8, _hoisted_52))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createTextVNode(_toDisplayString(_ctx.ba.unterschrifts.length > 1 && _ctx.ba.unterschrifts[1]?.position
                      ? _ctx.ba.unterschrifts[1]?.position
                      : "Projektmanager") + ": " + _toDisplayString(_ctx.ba.unterschrifts.length > 1 && _ctx.ba.unterschrifts[1]?.name
                      ? _ctx.ba.unterschrifts[1]?.name
                      : "_________") + " am " + _toDisplayString(_ctx.moment(_ctx.ba.begehungsdatum).format("DD.MM.YYYY")), 1),
                        _hoisted_55
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      (_ctx.ba.technProjektsteuerungUnterschrift)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.getPhotoUrl(_ctx.ba.technProjektsteuerungUnterschrift),
                            class: "object-cover mt-1",
                            style: {"height":"70px"}
                          }, null, 8, _hoisted_58))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("p", _hoisted_61, [
                          _createTextVNode(" freigegeben am "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.ba.freigabeDatum
                          ? _ctx.moment(_ctx.ba.freigabeDatum).format("DD.MM.YYYY")
                          : "_________"), 1)
                        ]),
                        _createElementVNode("p", _hoisted_62, [
                          _createTextVNode(" Technische Projektsteuerung "),
                          (_ctx.ba.technProjektsteuerungName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_63))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.ba.technProjektsteuerungName), 1)
                        ]),
                        _hoisted_64
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["pdf-key"])
        ]))
      : _createCommentVNode("", true)
  ]))
}